import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Label, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from "reactstrap";
import { Link, useHistory, Redirect } from "react-router-dom";
import { isEmpty, size } from "lodash";
import { showToast } from '../../UI/ui-toast'
import { get_user_permissions } from "../../../helpers/custom_helper"

import DeleteModal from "../../../components/Common/DeleteModal";
import moment from "moment";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { get_sale_documents } from '../api/documentsApi';
import { get_current_sale } from '../../Sales/api/salesApi';

import default_avatar from "../../../assets/images/avatar_01.png";
import { numberWithCommas } from "pages/UI/numeric-helper";
var saleEdit, saleView, saleCreate, saleDelete;
class SaleDocuments extends Component {
    constructor(props) {
        super(props);
        this.node = React.createRef();
        this.state = {
            page: 1,
            sizePerPage: 10,
            listData: [],
            listdata: "",
            viewmodal: false,
            modal: false,
            isOpen: false,
            selectDate: false,
            deleteModal: false,
            recordDeleteID: null,
            redirect: null,
            currentSaleId: 0,
            currentSaleInfo: {},
        };
        this.handleRecordClick = this.handleRecordClick.bind(this);
        this.handleViewDocument = this.handleViewDocument.bind(this);
        // this.handleAddNominee = this.handleAddNominee.bind(this);
        // this.handleListNominee = this.handleListNominee.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleRecordClicks = this.handleRecordClicks.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.handleEditSale = this.handleEditSale.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
    }
    componentDidMount() {
        saleEdit = get_user_permissions('sales-edit');
        saleView = get_user_permissions('sales-view');
        saleCreate = get_user_permissions('sales-create');
        saleDelete = get_user_permissions('sales-delete');
        // window.localStorage.removeItem("current_customer_id")
        // 
        console.log("current_sale_id", localStorage.getItem("current_sale_id"));
        this.setState({ currentSaleId: localStorage.getItem("current_sale_id") });

        
        Promise.all([get_current_sale(localStorage.getItem("current_sale_id"))]).then((values) => {
            console.log("currentSaleInfo", values[0]);
            this.setState({ currentSaleInfo: values[0] });
        });
        Promise.all([get_sale_documents(localStorage.getItem("current_sale_id"))]).then((values) => {
            console.log(values[0]);
            this.setState({ listData: values[0] });
        });

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { listData } = this.props;
        if (!isEmpty(listData) && size(prevProps.listData) !== size(listData)) {
            this.setState({ listData: {}, isEdit: false });
        }
    }
    onPaginationPageChange = page => {
        if (
            this.node &&
            this.node.current &&
            this.node.current.props &&
            this.node.current.props.pagination &&
            this.node.current.props.pagination.options
        ) {
            this.node.current.props.pagination.options.onPageChange(page);
        }
    };
    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }

    handleEditSale = () =>{
        window.localStorage.setItem("current_sale_id", this.state.currentSaleId);
        this.setState({ redirect: "/sales/edit" });
    }

    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = listdata => {
        // this.setState({ listdata: listdata });
        // this.setState({ deleteModal: true });
    };

    handleDeletejob = () => {
        // // const { onDeleteJobList } = this.props;
        // const { listdata } = this.state;
        // if (listdata.id !== undefined) {
        //     console.log(this.state.recordDeleteID);
        //     // onDeleteJobList(listdata);
        //     Promise.all([delete_document(this.state.recordDeleteID)]).then((values) => {
        //         showToast("Success", "The document deleted successfully.", "success");
        //         Promise.all([get_customer_documents(this.state.currentCustomerId)]).then((values) => {
        //             console.log(values[0]);
        //             this.setState({ listData: values[0] });
        //         });
        //     }).catch((error) => {
        //         showToast("Customer", "Document Not Deleted.", "error");
        //     });
        //     this.setState({ deleteModal: false });
        // }
    };
    handleRecordClicks = () => {
        this.setState({ listdata: "", isEdit: false });
        this.toggle();
    };

    onClickDownload = listdata => {
        const contentType = listdata.document_path.split(';')[0].split(':')[1];
        const base64Content = listdata.document_path.split(',')[1];
        const byteCharacters = atob(base64Content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const extension = listdata.document_path.split(';')[0].split('/')[1];
        const blob = new Blob([byteArray], { type: contentType });
        const fileName = `${listdata.document_name}.${extension}`;
      
        setTimeout(() => {
            if (contentType.startsWith('image/png') || contentType.startsWith('image/jpg') || contentType.startsWith('image/jpeg')) {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.click();
            } else {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.target = '_blank';
                a.rel = 'noopener noreferrer';
                a.click();
            }
        }, 100);
      };
    handleRecordClick = arg => {
        const listdata = arg;

        // window.localStorage.setItem("current_customer", this.state.currentCustomerId);
        // this.setState({ redirect: "/customers/edit" });
        

    };
    
    handleViewDocument = arg => {
        const listdata = arg;
        window.localStorage.setItem("current_document_id", listdata.id);
        alert("Work in progress!!!!!!!!!!!");
        return;
        // this.setState({ redirect: "/documents/view" });
    };

    // handleAddNominee = arg => {
    //     const listdata = arg;
    //     window.localStorage.setItem("current_customer_id", listdata.id);
    //     this.setState({ redirect: "/customer/nominee/add" });
    // };
    
    // handleListNominee = arg => {
    //     const listdata = arg;
    //     window.localStorage.setItem("current_customer_id", listdata.id);
    //     this.setState({ redirect: "/customer/nominees/list" });
    // };
    render() {

        const { isEdit, deleteModal } = this.state;

        const listdata = this.state.listdata;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        const columns = [
            {
                dataField: "document_name",
                text: "Document Name",
                sort: true,
            },
            {
                dataField: "document_sub_type_name",
                text: "Document Type",
                sort: true,
            },
            {
                dataField: "updated_at",
                text: "Generated At",
                sort: true,
                formatter: (cellContent, listdata) => (
                    <>
                        {moment(listdata.updated_at).format('DD/MM/YYYY h:mma')}
                    </>

                ),
            },
            {
                dataField: "action",
                isDummyField: true,
                text: "Action",
                formatter: (cellContent, listdata) => (
                    <>
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                            <Link
                                    to="#"
                                    onClick={() => this.onClickDownload(listdata)}
                                    className="btn btn-sm btn-soft-info" >
                                    <i className="mdi mdi-file-download-outline" id="downloadDocument" />
                                    <UncontrolledTooltip placement="top" target="downloadDocument">
                                        Download Document
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    </>
                ),
            },

        ];

        const defaultSorted = [
            {
                dataField: "id",
                order: "asc",
            },
        ];

        const pageOptions = {
            sizePerPage: 10,
            custom: true,
        };

        // Select All Button operation
        const selectRow = {
            mode: "checkbox",
        };

        const { SearchBar } = Search;

        //meta title
        document.title = "Documents of a Sale";
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                console.log(row);
                this.setState({ recordDeleteID: row.id });

            }
        }
        return (
            <React.Fragment>
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeletejob}
                    record={`documents`}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <div className="container-fluid">
                        <Breadcrumbs title="Sale Documents" breadcrumbItem="List Documents" parentLink="/documents/sales" />
                        <Row>
                            <Col xl="12">
                                <Card>
                                  <CardBody className="border-bottom">
                                    <h5 className="mb-3 card-title flex-grow-1">Sale Details</h5>
                                      <div className="d-flex">
                                        <div className="flex-grow-1 ms-3">
                                              <h5 className="fw-semibold">Property Name: {this.state.currentSaleInfo.property_name}</h5>
                                              <ul className="list-unstyled gap-2 mb-0">
                                                  <li>
                                                      <label>Project Name:&nbsp;</label><span className="text-muted">{this.state.currentSaleInfo.project_name}</span>
                                                  </li>
                                                  <li>
                                                      <label>Sale Date:&nbsp;</label><span className="text-muted">{this.state.currentSaleInfo.sale_date}</span>
                                                  </li>
                                                  <li>
                                                      <label>Status:&nbsp;</label><span className="text-muted">{this.state.currentSaleInfo.status}</span>
                                                  </li>
                                                  <li>
                                                      <label>Price:&nbsp;</label><span className="text-muted">{this.state.currentSaleInfo.currency_symbol}&nbsp;&nbsp;{numberWithCommas(this.state.currentSaleInfo.sale_total)}</span>
                                                  </li>
                                              </ul>
                                        </div>
                                      </div>
                                  </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1">List Sale Documents</h5>
                                                {saleEdit ? <>
                                                    <div className="flex-shrink-0">
                                                        <Link to="/sales/edit" className="btn btn-primary me-1" onClick={() => this.handleEditSale()}>Edit Sale</Link>
                                                    </div>
                                                </> : <></>}
                                            </div>
                                        </CardBody>
                                        <PaginationProvider
                                            pagination={paginationFactory(pageOptions)}
                                            keyField="id"
                                            columns={columns}
                                            data={this.state.listData}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="id"
                                                    columns={columns}
                                                    data={this.state.listData}
                                                    search
                                                >
                                                    {toolkitProps => (
                                                        <React.Fragment>
                                                            <Row className="mb-2">
                                                                <Col md="4">
                                                                    <div className="search-box me-2 mb-2 d-inline-block">
                                                                        <div className="position-relative">
                                                                            <SearchBar
                                                                                {...toolkitProps.searchProps}
                                                                            />
                                                                            <i className="bx bx-search-alt search-icon" />
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col xl="12">
                                                                    <div className="table-responsive">
                                                                        <BootstrapTable
                                                                            keyField={"id"}
                                                                            responsive
                                                                            bordered={false}
                                                                            striped={false}
                                                                            defaultSorted={defaultSorted}
                                                                            selectRow={selectRow}
                                                                            rowEvents={rowEvents}
                                                                            classes={
                                                                                "table align-middle table-nowrap"
                                                                            }
                                                                            headerWrapperClasses={"thead-light"}
                                                                            {...toolkitProps.baseProps}
                                                                            {...paginationTableProps}
                                                                            ref={this.node}
                                                                        />
                                                                        <Modal
                                                                            isOpen={this.state.modal}
                                                                            className={this.props.className}
                                                                        >
                                                                            <ModalHeader toggle={this.toggle} tag="h4">
                                                                                {!!isEdit ? "Edit Sale" : "Add Sale"}
                                                                            </ModalHeader>
                                                                            <ModalBody>
                                                                                <Formik
                                                                                    enableReinitialize={true}
                                                                                    initialValues={{
                                                                                        id: (listdata && listdata.id) || '',
                                                                                        name: (listdata && listdata.name) || '',
                                                                                    }}
                                                                                    validationSchema={Yup.object().shape({
                                                                                        id: Yup.string().required("Please Enter Your Id"),
                                                                                        name: Yup.string().required("Please Enter Your Name"),
                                                                                    })}
                                                                                    onSubmit={values => {
                                                                                        
                                                                                        this.toggle();
                                                                                    }}
                                                                                >
                                                                                    {({ errors, status, touched }) => (
                                                                                        <Form>
                                                                                            <Row>
                                                                                                <Col className="col-12">
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Property Type Id
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="id"
                                                                                                            disabled
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.id &&
                                                                                                                    touched.id
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="id"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="mb-3">
                                                                                                        <Label className="form-label">
                                                                                                            Name
                                                                                                        </Label>
                                                                                                        <Field
                                                                                                            name="name"
                                                                                                            type="text"
                                                                                                            className={
                                                                                                                "form-control" +
                                                                                                                (errors.name &&
                                                                                                                    touched.name
                                                                                                                    ? " is-invalid"
                                                                                                                    : "")
                                                                                                            }
                                                                                                        />
                                                                                                        <ErrorMessage
                                                                                                            name="name"
                                                                                                            component="div"
                                                                                                            className="invalid-feedback"
                                                                                                        />
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                            <Row>
                                                                                                <Col>
                                                                                                    <div className="text-end">
                                                                                                        <button
                                                                                                            type="submit"
                                                                                                            className="btn btn-primary save-user"
                                                                                                        >
                                                                                                            Save
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Form>
                                                                                    )}
                                                                                </Formik>
                                                                            </ModalBody>
                                                                        </Modal>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="align-items-md-center mt-30">
                                                                <Col className="inner-custom-pagination d-flex">
                                                                <div className="d-inline">Results Per Page&nbsp;&nbsp;
                                                                        <SizePerPageDropdownStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                    <div className="text-md-right ms-auto">
                                                                        <PaginationListStandalone
                                                                            {...paginationProps}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default SaleDocuments;
